import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Switch, SingleLineText } from '@bloomays-lib/ui.shared';
import FilterTab from '../atoms/FilterTab';
import { DesiredContractType } from '@bloomays-lib/types.shared';
import { Action, ActionType, TalentSearchState } from '../../types/talents';

export type FilterStatusProps = {
  onSwitch: React.Dispatch<Action>;
  state: TalentSearchState;
  cdi: boolean;
  freelance: boolean;
  setFreelance: React.Dispatch<React.SetStateAction<boolean>>;
  setCdi: React.Dispatch<React.SetStateAction<boolean>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
};

const FilterStatus = ({ onSwitch, state, cdi, freelance, setFreelance, setCdi, setPage }: FilterStatusProps) => {
  const status = state.search.status;
  const [open, setOpen] = useState(false);

  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, status]);

  const getMergedStatus = (f: boolean, c: boolean) => {
    let statusSwitch: DesiredContractType | undefined;

    if (f && c) {
      statusSwitch = DesiredContractType.FreeAndCDI;
    }
    if (f && !c) {
      statusSwitch = DesiredContractType.Freelance;
    }
    if (!f && c) {
      statusSwitch = DesiredContractType.CDI;
    }
    return statusSwitch;
  };

  const handleSwitchFreelance = (checked: boolean) => {
    setFreelance(checked);

    onSwitch({
      type: ActionType.STATUS_SEARCH,
      status: getMergedStatus(checked, cdi),
    });
    setPage(1);
  };

  const handleSwitchCDI = (checked: boolean) => {
    setCdi(checked);
    onSwitch({
      type: ActionType.STATUS_SEARCH,
      status: getMergedStatus(freelance, checked),
    });
    setPage(1);
  };

  const getNumberFilter = () => {
    switch (status) {
      case DesiredContractType.Freelance:
      case DesiredContractType.CDI:
        return 1;
      case DesiredContractType.FreeAndCDI:
        return 2;
      default:
        return 0;
    }
  };

  return (
    <div>
      <FilterTab label={'Statut'} numberOfFilter={getNumberFilter()} onClick={() => setOpen(!open)} filled={false} />
      {open && (
        <StyledContainer ref={ref}>
          <StyledText text="Statut" variant={'subtitle2Medium'} />
          <StyledList>
            <Switch checked={freelance} label="Freelance" onSwitch={() => handleSwitchFreelance(!freelance)} />
            <Switch checked={cdi} label="CDI" onSwitch={() => handleSwitchCDI(!cdi)} />
          </StyledList>
        </StyledContainer>
      )}
    </div>
  ) as React.ReactNode;
};

export default FilterStatus;
export { FilterStatus };

const StyledContainer = styled('div')(
  ({ theme }) => `
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  border-radius: 20px;
  padding: 24px;
  background-color: ${theme.palette.neutral.white};
  gap: 10px;
  box-shadow: 0px 10px 40px rgba(140, 140, 140, 0.2);
  width: 291px;
  position: absolute;
  z-index: 1;
`,
);

const StyledList = styled('div')(
  () => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`,
);

const StyledText = styled(SingleLineText)(
  ({ theme }) => `
  color: ${theme.palette.neutral[50]};
`,
);
